// extracted by mini-css-extract-plugin
export default {"productLink":"HtU_Q"};